import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import { MessageDeliveryStatus, describeAutomaticRetries } from '@common/clientServerApi';
function deliveryNote(message, formatTime) {
    const attempts = message.deliveryRetry?.attempts ?? 0;
    const nextAttemptAtUtc = message.deliveryRetry?.nextAttemptAtUtc ?? null;
    if (message.deliveryStatus === MessageDeliveryStatus.Failed) {
        const reason = message.deliveryError ?? 'the carrier couldn\'t deliver it';
        if (nextAttemptAtUtc !== null) {
            const text = attempts === 0
                ? `Not delivered: ${reason}. Retrying automatically at ${formatTime(nextAttemptAtUtc)}.`
                : `Still not delivered after ${describeAutomaticRetries(attempts)}: ${reason}. `
                    + `Retrying again at ${formatTime(nextAttemptAtUtc)}.`;
            return { Icon: ScheduleRoundedIcon, color: 'warning.dark', text };
        }
        const text = attempts === 0
            ? `Not delivered: ${reason}.`
            : `Not delivered after ${describeAutomaticRetries(attempts)}: ${reason}.`;
        return { Icon: ErrorOutlineRoundedIcon, color: 'error.main', text };
    }
    if (attempts === 0)
        return null;
    const text = message.deliveredAtUtc !== undefined
        ? `Delivered after ${describeAutomaticRetries(attempts)}.`
        : 'Sent again automatically after it wasn\'t delivered.';
    return { Icon: ReplayRoundedIcon, color: 'text.secondary', text };
}
export function MessageDeliveryNote({ message, formatTime }) {
    const note = deliveryNote(message, formatTime);
    if (note === null)
        return null;
    const { Icon, color, text } = note;
    return (_jsxs(Stack, { "data-testid": "message-delivery-note", direction: "row", spacing: 0.5, alignItems: "flex-start", sx: { mt: 0.5 }, children: [_jsx(Icon, { "aria-hidden": true, sx: { fontSize: 16, mt: '1px', color } }), _jsx(Typography, { variant: "caption", sx: { color, minWidth: 0, overflowWrap: 'anywhere' }, children: text })] }));
}
